// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UkwgK","rootMobile":"styles_rootMobile__3164D"};